// extracted by mini-css-extract-plugin
module.exports = {"mailMenu__actionsBlock":"mailMenu_mailMenu__actionsBlock__3gb8A"};